import serverFetch from '../utils/serverFetch'

// Get all public resources
export async function get_all_public_resources() {
  return serverFetch({
    method: 'GET',
    endpoint: '/resources/public'
  })
}

// Get all resources (admin)
export async function get_all_resources() {
  return serverFetch({
    method: 'GET',
    endpoint: '/resources'
  })
}

// Get resource by ID
export async function get_resources_by_id(resource_id) {
  return serverFetch({
    method: 'GET',
    endpoint: `/resources/id/${resource_id}`
  })
}

// Create new resource
export async function create_new_resources(resourceData) {
  return serverFetch({
    method: 'POST',
    endpoint: '/resources',
    body: JSON.stringify(resourceData),
  })
}

// Update resource
export async function update_resources(resource_id, resourceData) {
  return serverFetch({
    method: 'PUT',
    endpoint: `/resources/id/${resource_id}`,
    body: JSON.stringify(resourceData),
  })
}

// Delete resource
export async function delete_resources(resource_id) {
  return serverFetch({
    method: 'DELETE',
    endpoint: `/resources/id/${resource_id}`
  })
}
